import FileItem from './components/FileItem';
import Uploader from './components/Uploader';

const UploadFiles = ({ files, onUpload, onDelete }) => {
	return (
		<div className='UploadFiles'>
			<div className='UploadFiles__content'>
				<Uploader onUpload={onUpload} />
				<div className='UploadFiles__items FormBlock'>
					{files.map((file, index) => (
						<>
							<FileItem
								file={file}
								isError={file.status === 'Error'}
								isLoading={file.status === 'Loading'}
								bottomSeparator={index !== files.length - 1}
								onDelete={() => onDelete(file)}
							/>
						</>
					))}
				</div>
			</div>
		</div>
	);
};

export default UploadFiles;
